import { Trophy, TrendingUp, TrendingDown, Minus } from "lucide-react";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { LEVEL_INFO } from "@/lib/api";
import { BadgeCard } from "@/components/BadgeCard";

export function ResultView({ result }) {
  const nav = useNavigate();
  const { score, total, previous_level, new_level, level_changed } = result;
  const up = level_changed && Object.keys(LEVEL_INFO).indexOf(new_level) > Object.keys(LEVEL_INFO).indexOf(previous_level);
  const Icon = !level_changed ? Minus : up ? TrendingUp : TrendingDown;
  const newBadges = useMemo(() => (result.new_badges || []).map((b) => ({ ...b, earned: true })), [result.new_badges]);
  const msg = result.offline
    ? "Hors ligne : résultat gardé, il sera envoyé au retour du réseau."
    : !level_changed
    ? `Vous restez au niveau ${LEVEL_INFO[new_level].label}.`
    : up
    ? `Bravo ! Prochaine leçon : niveau ${LEVEL_INFO[new_level].label}.`
    : `On revient au niveau ${LEVEL_INFO[new_level].label} pour consolider.`;

  return (
    <div className="space-y-6 text-center rise" data-testid="lesson-result">
      <div className="mx-auto w-24 h-24 rounded-full bg-amber-400 grid place-items-center shadow-lg">
        <Trophy className="w-12 h-12 text-slate-900" />
      </div>
      <div>
        <p className="text-sm font-bold uppercase text-slate-500">Votre score</p>
        <p className="font-display text-7xl font-extrabold" data-testid="result-score-display">
          {score}/{total}
        </p>
      </div>
      <div
        data-testid="result-level-update-notice"
        className={`rounded-2xl border-2 p-4 flex items-center gap-3 text-left ${LEVEL_INFO[new_level].cls}`}
      >
        <Icon className="w-8 h-8 shrink-0" />
        <p className="font-semibold">{msg}</p>
      </div>
      {result.certificate_id && (
        <button onClick={() => nav(`/certificat/${result.certificate_id}`)} data-testid="result-certificate-btn" className="w-full h-14 rounded-xl bg-amber-400 hover:bg-amber-500 text-slate-900 font-display text-xl font-bold uppercase transition-colors">
          Voir mon certificat
        </button>
      )}
      {newBadges.length > 0 && (
        <div className="space-y-2" data-testid="result-new-badges">
          <p className="text-sm font-bold uppercase text-orange-600">Nouveau badge !</p>
          <div className="grid grid-cols-3 gap-2">
            {newBadges.map((b) => <BadgeCard key={b.id} badge={b} />)}
          </div>
        </div>
      )}
      <button
        onClick={() => nav("/")}
        data-testid="result-finish-btn"
        className="w-full h-14 rounded-xl bg-orange-500 hover:bg-orange-600 text-white font-display text-xl font-bold uppercase transition-colors"
      >
        Retour à l'accueil
      </button>
    </div>
  );
}
